import React from 'react';
import { FadeIn } from './FadeIn';
export function ProtocoloHielo() {
  return <section className="py-16 md:py-32 bg-white" data-id="element-353">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-354">
        <FadeIn data-id="element-355">
          <div className="text-center mb-16" data-id="element-356">
            <span className="text-sage-600 font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-357">
              El Mecanismo Único
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-8" data-id="element-358">
              Presentamos el Protocolo{' '}
              <span className="text-coral-500" data-id="element-359">H.I.E.L.O.</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-360">
          <FadeIn direction="right" data-id="element-361">
            <div className="space-y-6" data-id="element-362">
              <div className="flex items-center gap-4" data-id="element-363">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-364">
                  H
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-365">
                  Hidratación Celular
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-366">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-367">
                  I
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-368">
                  Intestino Sano
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-369">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-370">
                  E
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-371">
                  Equilibrio de
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-372">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-373">
                  L
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-374">
                  Líquidos y
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-375">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-376">
                  O
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-377">
                  Oxitocina (Cortisol bajo)
                </span>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-378">
            <div className="bg-sage-50 rounded-3xl p-8 md:p-10 border border-sage-100 relative" data-id="element-379">
              <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-sage-200 rounded-full blur-2xl opacity-50" data-id="element-380"></div>
              <p className="text-lg text-charcoal-light leading-relaxed relative z-10" data-id="element-381">
                A diferencia de las dietas tradicionales, este protocolo no se
                enfoca en la restricción, sino en la{' '}
                <strong className="text-charcoal" data-id="element-382">
                  señalización biológica
                </strong>
                .
                <br data-id="element-383" />
                <br data-id="element-384" />
                Le enseñamos a tu sistema nervioso que "está a salvo" para que
                suelte la retención de líquidos, selle las paredes de tu
                intestino y apague la alarma del cortisol.
                <br data-id="element-385" />
                <br data-id="element-386" />
                <span className="text-xl font-serif italic text-sage-700" data-id="element-387">
                  Cuando la inflamación baja, el peso se cae solo.
                </span>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}